export default __webpack_public_path__ + "static/N0015-c6e111f6808bf9cb2cb8c65234f34f75.png";